export function useFormatDate() {
  const formatDateDDMMYYYY = (date: string) => {
    // Brak / niepoprawna data (np. projekt bez powiadomień) → pusty tekst zamiast „Invalid Date”.
    if (!date) return "";
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? "" : parsed.toLocaleDateString("pl-PL");
  };

  return { formatDateDDMMYYYY };
}
